import { render, staticRenderFns } from "./Add-novo-item-transferencia.vue?vue&type=template&id=12b45125&scoped=true&"
import script from "./Add-novo-item-transferencia.vue?vue&type=script&lang=js&"
export * from "./Add-novo-item-transferencia.vue?vue&type=script&lang=js&"
import style0 from "./Add-novo-item-transferencia.vue?vue&type=style&index=0&id=12b45125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b45125",
  null
  
)

export default component.exports